import { func, oneOf, string } from 'prop-types';
import React from 'react';
import { SCSubmitButton } from './styles';

SubmitButton.propTypes = {
  title: string.isRequired,
  buttonState: oneOf(['ready', 'attention', 'loading', 'disabled']).isRequired,
  clicked: func.isRequired,
};

function SubmitButton({ title, buttonState, clicked }) {
  return (
    <SCSubmitButton
      disabled={buttonState === 'disabled'}
      onClick={clicked}
      type="submit"
      state={buttonState}>
      {title}
    </SCSubmitButton>
  );
}

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/SubmitButton.js